import React from "react";
import { IonRow, IonCol } from '@ionic/react';
import Button from './Button';
import './MopFooterDealUpgrade.scss';
import { useHistory } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import { ApplicationState } from "../store";
import * as MenuItemStore from '../store/MenuItemStore';

function MopFooterDealUpgrade() {
    const history = useHistory();
    const dispatch = useDispatch();
    const menuItemId = useSelector((state: ApplicationState) => state.menuItemData?.menuItem?.menuItemId);

    const deal = useSelector((state: ApplicationState) => {
        return state.deal?.deals?.find(deal => deal.dealSku === state.deal?.currentDealSku);
    });

    const upgradedFromSku = useSelector((state: ApplicationState) => {
        return state.deal?.upgradedFromSku;
    });

    function handleCancel() {
        if (menuItemId) {
            history.replace(`/menuitem/${menuItemId}`);
        }
    }

    function handleUpgrade() {
        if (!deal) {
            console.error("deal is null");
            return;
        }

        dispatch(MenuItemStore.actionCreators.requestMenuItemBySku(deal.dealSku, "", upgradedFromSku, () => {
            const params = new URLSearchParams();
            params.set('page', '1');

            history.replace(`/deal/${menuItemId}?${params.toString()}`);
        }));
    }

    return (
        <div className="MopFooterInner">
            <IonRow className="ion-align-items-center">
                <IonCol size="6">
                    <Button
                        onClick={handleCancel}
                        //disabled={locationState?.selectedStore === undefined || locationState?.selectedStore.takingMopOrders === false}
                        expand="block"
                        color="light"
                        rounded
                    >
                        <div className="cancel-button">
                            <p className="deal-title">No thanks</p>
                            <p className="deal-sub">Add item only</p>
                        </div>
                    </Button>
                </IonCol>
                <IonCol size="6">
                    <Button
                        onClick={handleUpgrade}
                        //disabled={locationState?.selectedStore === undefined || locationState?.selectedStore.takingMopOrders === false}
                        expand="block"
                        color="secondary"
                        rounded
                    >
                        <div>
                            <p className="deal-title">Yes please</p>
                            <p className="deal-sub">Make it a deal</p>
                        </div>
                    </Button>
                </IonCol>
            </IonRow>
        </div>
    )
}

export default MopFooterDealUpgrade;
